import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

type MarkdownProps = {
    source: string;
};

export const Markdown: React.FunctionComponent<
    React.PropsWithChildren<MarkdownProps>
> = ({ source }) => (
    <ReactMarkdown rehypePlugins={[rehypeRaw]}>{source}</ReactMarkdown>
);
